'use client';

import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import { getClientApplicationConfig } from '@hc-frontend/core-context';
import { useCompleteTrackingContext } from '@hc-frontend/features-tracking';
import { useEffect } from 'react';

export function AmplitudeSessionReplay() {
  const context = useCompleteTrackingContext();
  const config = getClientApplicationConfig();

  useEffect(() => {
    initialize(
      config.core.appEnvironment,
      config.amplitude.identify.apiKey,
      context.tracker.getDomainUserId(),
    );
  }, []);

  return null;
}

async function initialize(env: string, apiKey: string, domainUserId: string) {
  if (env === 'prd') {
    await amplitude.init(apiKey, domainUserId, {
      autocapture: false,
    }).promise;
    const sessionReplayTracking = sessionReplayPlugin({
      sampleRate: 0.2,
    });
    amplitude.add(sessionReplayTracking);
  }
}
